import DeleteIcon from '@atlaskit/icon/core/delete';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { analyticsClient } from '@databases/analytics';
import { messages } from '@databases/intl/messages';
import React from 'react';

import { deleteEntries } from '../actions/delete-entries';
import { onMouseEnterDeleteEntryButton } from '../actions/on-mouse-enter-delete-entry-button';
import { onMouseLeaveDeleteButton } from '../actions/on-mouse-leave-delete-button';
import { onLeaveDeleteEntryButton } from '../actions/on-mouse-leave-delete-entry-button';
import { type MenuItemBuilder, SELECT_VALUE_MENU_ACTIONS } from '../types';
import { ElementBeforeIconWrapper } from '../ui/components';

export const deleteEntriesMenuItem: MenuItemBuilder = ({
  capabilities: { canDeleteEntries },
  formatMessage,
  selectedEntriesCount,
  isHoverDeleteEntriesButton,
  contentId,
  selectedEntryIds,
  panelManager,
}) => {
  const { entryId: panelEntryId } = panelManager.getData('EntryViewPanel') || {};

  return {
    isEnabled: () => canDeleteEntries,
    menuItem: {
      key: SELECT_VALUE_MENU_ACTIONS.DELETE_ENTRIES,
      content: formatMessage(messages['entry-actions.delete'], {
        entryCount: selectedEntriesCount.toString(),
      }),
      onClick: () => {
        deleteEntries({
          contentId,
          client: analyticsClient,
          hidePanel: panelManager.hidePanel,
          panelEntryId,
        });

        onMouseLeaveDeleteButton();
      },
      closeOnClick: true,
      onMouseEnter: () => onMouseEnterDeleteEntryButton(selectedEntryIds, contentId),
      onMouseLeave: () => onLeaveDeleteEntryButton(selectedEntryIds, contentId),
      elemBefore: (
        <ElementBeforeIconWrapper>
          <DeleteIcon
            label=""
            spacing="spacious"
            color={
              isHoverDeleteEntriesButton
                ? token('color.icon.danger', colors.R500)
                : undefined
            }
          />
        </ElementBeforeIconWrapper>
      ),
    },
  };
};
